import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyC2Ar-kje76Q-2Cdyp6J8pWfBbsSc_ghcU",
    authDomain: "liquidatorrptulua.firebaseapp.com",
    projectId: "liquidatorrptulua",
    storageBucket: "liquidatorrptulua.appspot.com",
    messagingSenderId: "1003598420496",
    appId: "1:1003598420496:web:a2f9ea88159826e2540895"
};

export const fb = firebase.initializeApp(firebaseConfig);
export const admin = firebase.firestore.FieldValue;